/* unplugin-vue-components disabled */import { render } from "./member_welfare_m.vue?vue&type=template&id=74ca84e6&scoped=true"
import script from "./member_welfare_m.vue?vue&type=script&lang=js"
export * from "./member_welfare_m.vue?vue&type=script&lang=js"

import "./member_welfare_m.vue?vue&type=style&index=0&id=74ca84e6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74ca84e6"]])

export default __exports__